import { render, staticRenderFns } from "./WizardNav.vue?vue&type=template&id=3b7b8b00&scoped=true"
import script from "./WizardNav.vue?vue&type=script&lang=js"
export * from "./WizardNav.vue?vue&type=script&lang=js"
import style0 from "./WizardNav.vue?vue&type=style&index=0&id=3b7b8b00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7b8b00",
  null
  
)

export default component.exports